// extracted by mini-css-extract-plugin
module.exports = {"card":"PricingFactorCard_card__7dM_T","accentLine":"PricingFactorCard_accentLine__gG7rt","title":"PricingFactorCard_title__S1pCp","description":"PricingFactorCard_description__B55zo"};
module.exports.__checksum = "331f804eb9ff"
